module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/boxoffice-module/components/product-pill-group/product-pill-group.component.scss
// module id = ./src/app/modules/boxoffice-module/components/product-pill-group/product-pill-group.component.scss
// module chunks = 9